<template>
	<el-dialog :visible.sync="pdflb" width="0px" append-to-body class="el-dialog-pdflb"
		:before-close="handleClickpdflb">

		<div>
			<div class="x-tc-page-bg">
				<div class="x-tc-title douyuFont">
					<div v-if="pdfName!=''">
						{{pdfName}}
					</div>
					<div v-else>
						查看详情
					</div>

				</div>
				<div class="x-close" @click="closeClick"></div>
				<div class="x-tc-cnt">
					<div class="biaoti">
						<span class="bt_span" style="width:150px;">序号</span>
						<span class="bt_span" style="width:640px;">文件名称</span>
						<span class="bt_span" style="width:150px;">操作</span>
					</div>
						<img src="~@/assets/common/hengtiao.png"
							style="width: 940px;height: 8px;float: left; margin-left: 72.5px;" />
					<div class="xia">
						<div v-for="(item,index) of pdflistArr" :key="index">
							<div class="neirong" :class=" index%2==0 ? 'beijingwuse' : 'beijinglanse'">
								<span class="nr_span" style="width:150px;">{{index+1+(currentPage-1)*10}}</span>
								<span class="nr_span" style="width:640px;">{{item.name}}</span>
								<span class="nr_span" style="width:150px;color: #91ecff;cursor: pointer;"
									@click="lookPDF(item.url,item.name)">查看</span>
							</div>
						</div>
					</div>
					<!-- <div class="fanye">
						<div class="block">
							<el-pagination background layout="prev, pager, next" :total="total"
								:current-page.sync="currentPage" @current-change="getbaojinglist">
							</el-pagination>
						</div>
					</div> -->

				</div>
			</div>
		</div>
		<chakanPDF ref="dialog" v-if="chakanpdf" :chakanpdfId="chakanpdfId" :chakanpdfName="chakanpdfName"
			@on-point="chakanpdf=false">
		</chakanPDF>
	</el-dialog>
</template>

<script>
	import {
		getDictData
	} from "@/utils/dict";
	import {
		baojinglist
	} from "@/api/dapingshuiqingcanbao/baojinglist";
	import chakanPDF from "@/views/ShuiKuZongHe/zonghetaishi/zujian/chakanPDF";
	export default {
		name: "index",
		components: {

			chakanPDF,
		},
		props: {
			/* pdflbId: {
				type: Number,
				default: 0
			}, */
			pdflist: {
				type: String,
				default: ""
			},
			pdfName: {
				type: String,
				default: ''
			}
		},
		data() {
			return {

				chakanpdf: false,
				chakanpdfId: '',
				chakanpdfName: '',

				// 弹出层标题
				pdflb: true,
				// yujing: this.pdflbId,
				currentPage: 1,
				total: 0,
				liebiaoneirong: [],
				// 类型字典
				event_type: [],
				pdflistArr: []


			}
		},

		created() {

		},

		mounted() {
			let arr = this.pdflist.split(",");
			let that = this
			arr.forEach(function(item) {
				let names = item.split("/");
				let index = names[names.length - 1].lastIndexOf("_");
				let obj = {
					"name": names[names.length - 1].substring(0, index),
					"url": item
				}
				that.pdflistArr.push(obj)
			})

			console.log("+++++" + this.pdflist)

			/* getDictData("event_type").then((val) => {
				this.event_type = val;
				console.log(this.event_type)
			}); */
			// this.getbaojinglist()

		},
		beforeDestroy() {

		},
		methods: {
			// getbaojinglist() {
			// 	baojinglist({
			// 		pageNum: this.currentPage,
			// 		pageSize: 10,
			// 		alertLevel: 1 //告警级别（1=动态消息，2=报警事件，3=预警事件）
			// 	}).then(response => {
			// 		if (response.code == 200) {
			// 			this.liebiaoneirong = response.rows;
			// 			this.total = response.total
			// 			console.log("成功：" + this.liebiaoneirong)
			// 		}
			// 	})
			// },
			// handleClickchakanpdf(data) {
			// 	console.log("当前被点击的id" + data)
			// 	this.chakanpdfId = data;
			// 	this.chakanpdf = true;
			// },

			lookPDF(url, name) {
				this.chakanpdfId = url
				this.chakanpdfName = name
				this.chakanpdf = true
			},


			handleClickpdflb() {
				this.$emit('on-point')

			},

			closeClick() {
				this.$emit('on-point')
			},

		}
	}
</script>
<style scoped>
	.beijingwuse {
		background-color: #0d3955;

	}

	.beijinglanse {
		background-color: #104d7b;

	}

	.biaoti {

		background-color: #104d7b;
		width: 940px;
		height: 61px;
		margin-top: 40px;
		margin-left: 72.5px;
		float: left;
		/* border: #fff solid 1px; */

	}

	.bt_span {
		float: left;
		color: #fff;
		margin-top: 0px;
		margin-left: 0px;
		/* width: 188px; */
		height: 61px;

		display: block;
		font-size: 18px;
		line-height: 66px;
		font-weight: bold;
		text-align: center
	}

	.nr_span {
		float: left;
		color: #fff;
		margin-top: 0px;
		margin-left: 0px;
		/* width: 188px; */
		height: 54px;

		/* display: block; */
		font-size: 17px;
		/* line-height: 55px; */
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		/* 设置为单行文本 */
		/* white-space: nowrap; */
		/* 设置溢出时显示省略号 */
		/* text-overflow: ellipsis; */
		/* 设置元素宽度，并让文本在该宽度内截断 */
		/* 设置元素内容溢出部分隐藏 */
		/* overflow: hidden; */
		/* 设置元素为块级元素，这样才能进行宽度限制 */
		/* display: inline-block; */
	}

	.neirong {

		/* background-color: #104d7b; */
		width: 940px;
		height: 54px;
		margin-top: 0px;
		margin-left: 0px;
		float: left;
		border-bottom: #1c7bb1 solid 1px;


	}

	.xia {
		width: 940px;
		height: 594px;
		margin-top: 0px;
		margin-left: 72.5px;
		float: left;
		/* border: #fff solid 1px; */
			overflow-x: hidden;
		overflow-y: scroll;
	}

	.fanye {
		width: 940px;
		height: 58px;
		margin-top: 20px;
		margin-left: 72.5px;
		float: left;

	}

	.block {
		height: 46px;
		margin-top: 12px;
		float: right;

	}
	
	.x-tc-page-bg {
		background: url("~@/assets/common/tanChuang.png") no-repeat;
		background-size: 100% 100%;
		width: 1132px;
		height: 813px;
		position: fixed;
		top: 100px;
		left: 400px;
		z-index: 99999;
	}

	.x-tc-title {
		font-size: 22px;
		position: absolute;
		left: 80px;
		top: 15px;
		color: white;
		letter-spacing: 0px;
	}

	.x-close {
		width: 50px;
		height: 50px;
		position: absolute;
		right: 30px;
		cursor: pointer;
	}


	.x-tc-cnt {
		width: 1085px;
		height: 750px;
		position: absolute;
		left: 22px;
		top: 58px;
		overflow: hidden;
	}
</style>